import { render, staticRenderFns } from "./Student.vue?vue&type=template&id=77ee04fa&scoped=true&"
import script from "./Student.vue?vue&type=script&lang=ts&"
export * from "./Student.vue?vue&type=script&lang=ts&"
import style0 from "./Student.vue?vue&type=style&index=0&id=77ee04fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77ee04fa",
  null
  
)

export default component.exports